const flaggedContentHR = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Pogledaj detalje"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "Izdanje <strong>{{releaseName}}</strong> je dodano na bijelu listu.",
                "releaseHasFlaggedContent": "Izdanje <strong>{{releaseName}}</strong> sadrži označene pjesme. Naknada od <strong>15 €</strong> po označenoj pjesmi primjenjuje se za isporuku na <strong>Spotify</strong>.<br/><br/> Kliknite gumb ispod kako biste dovršili uplatu i nastavili."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Detalji o označenim pjesmama",
                    "titleFlaggedTrackPayment": "Plaćanje za bijelu listu Spotify"
                },
                "body": {
                    "table": {
                        "title": "Sljedeće pjesme su označene. Molimo pregledajte detalje ispod:",
                        "column": {
                            "name": "Naziv pjesme",
                            "flaggedArtist": "Označeni izvođač",
                            "payableAmount": "Iznos za plaćanje",
                            "paymentStatus": "Status plaćanja"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PLAĆENO",
                            "pending": "NA ČEKANJU",
                        },
                    },
                    "label": {
                        "processingPayment": "Obrada plaćanja...",
                        "paymentSuccessful": "Plaćanje uspješno!",
                        "paymentFailed": "Plaćanje nije uspjelo!"
                    },
                    "message": {
                        "totalPayableAmount": "Za dovršetak isporuke vašeg izdanja na <strong>Spotify</strong>, potreban je povratni depozit od <strong>{{totalAmount}} €</strong>. Molimo prihvatite dolje navedene uvjete i kliknite gumb <strong>Nastavi</strong> kako biste izvršili uplatu.",
                        "escrowAmountAgreement": "Prihvaćam i potvrđujem da će iznos depozita od <strong>{{totalAmount}} €</strong> biti položen od strane mene. Ovaj iznos će biti zadržan do <strong>kraja pretplate</strong> i, pod uvjetom da ne dođe do problema, bit će mi vraćen na kraju ovog razdoblja. Međutim, ako prekršim uvjete ovog sporazuma tijekom ovog vremena, iznos depozita će biti primijenjen na nepodmireni račun i neće biti vraćen. Nastavljajući, potvrđujem svoje razumijevanje i prihvaćanje ovih uvjeta.",
                        "escrowPaymentRejected": "Ne prihvaćam uvjete plaćanja depozita i, sukladno tome, priznajem da moje izdanje <strong>{{releaseName}}</strong> <strong>neće biti distribuirano na Spotify</strong>.",
                        "consentRecordedSuccessfully": "Suglasnost uspješno zabilježena!"
                    }
                },
                "button": {
                    "proceed": "Nastavi"
                }
            }
        }
    }
}

export default flaggedContentHR;